import React, { createContext, useContext, useState, ReactNode } from "react";
import { TabItem } from "@/components/lheader/components/BottomTabs";

interface BottomTabsContextType {
  tabs: TabItem[];
  setTabs: (tabs: TabItem[] | ((prevTabs: TabItem[]) => TabItem[])) => void;
  selectedTabId: string | null;
  setSelectedTabId: (id: string | null) => void;
}

const BottomTabsContext = createContext<BottomTabsContextType | undefined>(
  undefined
);

export const useBottomTabs = () => {
  const context = useContext(BottomTabsContext);
  if (context === undefined) {
    throw new Error("useBottomTabs must be used within a BottomTabsProvider");
  }
  return context;
};

interface BottomTabsProviderProps {
  children: ReactNode;
}

export const BottomTabsProvider: React.FC<BottomTabsProviderProps> = ({
  children,
}) => {
  const [tabs, setTabs] = useState<TabItem[]>([]);
  const [selectedTabId, setSelectedTabId] = useState<string | null>(null);

  const value = {
    tabs,
    setTabs,
    selectedTabId,
    setSelectedTabId,
  };

  return (
    <BottomTabsContext.Provider value={value}>
      {children}
    </BottomTabsContext.Provider>
  );
};
